import type { HouseId } from "./schema.ts";

/**
 * Houses that actually have gameplay code. Remote config and static
 * metadata cannot make an unimplemented house playable.
 */
export const IMPLEMENTED_HOUSE_IDS: readonly HouseId[] = ["sorting", "colors", "tiles", "logic", "arcade", "fill"];
